import { DELETE_FUNDRAISE_UPDATES_LIST_API_URL } from "../components/Shared/constant";

const DeleteFundraiseUpdatesAPI = async (accessToken, id) => {
    const responce = window.axios.get(`${DELETE_FUNDRAISE_UPDATES_LIST_API_URL}/${id}`, {
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + accessToken,
    }}).then(function (result) {
        return {
          ...result.data,
          status:200
        };
    }).catch(function (result) {
        return {
          ...result?.response?.data,
          status:result?.response?.status
        }
    });
    return responce;
};
  
export default DeleteFundraiseUpdatesAPI;